import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { pushApi, type PushSendBody } from '@/api/push.api';

export const pushCampaignKeys = {
  stats: ['push', 'stats'] as const,
};

export function usePushStats() {
  return useQuery({
    queryKey: pushCampaignKeys.stats,
    queryFn: () => pushApi.stats(),
  });
}

export function useSendPush() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: PushSendBody) => pushApi.send(body),
    onSuccess: (res) => {
      if (res.sent === 0 && res.failed === 0) {
        toast('No hay dispositivos suscriptos todavía', { icon: '📭' });
      } else {
        toast.success(`Push enviada: ${res.sent} ✅${res.failed ? ` · ${res.failed} fallaron` : ''}`);
      }
      qc.invalidateQueries({ queryKey: pushCampaignKeys.stats });
    },
    onError: (err: Error) => toast.error(err.message || 'No se pudo enviar la push'),
  });
}
